<h1 mat-dialog-title>{{ title }}</h1>
<div mat-dialog-content>

    <div class="msg">
        {{ showMainMessage() }}
    </div>

    <div class="details">                
        <div *ngFor="let resultItem of resultItems" class="result-block">
            <h4>{{ resultItem.title }}</h4>
            <div class="subtitle">{{ resultItem.subtitle }}</div>
            <div class="details-content-item" *ngFor="let key of resultItem.keys">
                <div class="detail-message" [ngClass]="{'text-warning': !resultItem.isError, 'text-danger': resultItem.isError }">{{ getDetailMessage(key) }}</div>

                <ul *ngIf="resultItem.items[key] && resultItem.items[key].length > 0" class="employee-list">
                    
                    <li *ngFor="let item of resultItem.items[key]" class="employee-item">
                        <ng-container *ngIf="isEmployee(item)">
                            {{ item.name }} <span *ngIf="item.email">({{ item.email }})</span>
                        </ng-container>

                        <ng-container *ngIf="isItemNumber(item)">
                            {{ item }}
                        </ng-container>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</div>
<div mat-dialog-actions class="flex-h flex-end">
    <button mat-flat-button color="primary" (click)="continue()" *ngIf="!hasError && hasWarning"  type="submit">{{ 'ERROR_DETAILS_DIALOG.CONTINUE' | translate }}</button>
    <button mat-flat-button color="primary" (click)="close()" type="submit">{{ 'ERROR_DETAILS_DIALOG.FINISH' | translate }}</button>
</div>
